module.exports = __webpack_public_path__ + "img/2.c937c021.png";